import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

// Set the worker source - this should work with most bundlers
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [, setNumPages] = useState(null);
  const [pageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get responsive scale - dynamically fit to screen width
  const getResponsiveScale = () => {
    const screenWidth = window.innerWidth;
    const padding = 40; // Account for container padding

    if (screenWidth <= 480) {
      // Very small screens - fit to width
      return (screenWidth - padding) / 600;
    } else if (screenWidth <= 768) {
      // Mobile - fit to width  
      return (screenWidth - padding) / 600;
    } else if (screenWidth <= 1024) {
      // Tablet - slightly smaller scale
      return 0.85;
    } else {
      // Desktop - fixed reasonable scale to prevent stretching
      return 0.9; // Reduced from 1.0 to prevent excessive width
    }
  };

  // Handle window resize for mobile responsiveness
  useEffect(() => {
    const handleResize = () => {
      const newScale = getResponsiveScale();
      setScale(newScale);
    };

    // Set initial scale
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
    setError(null);
  }, []);

  const onDocumentLoadError = useCallback((error) => {
    setError("Failed to load PDF. Please try again.");
    setLoading(false);
    console.error("PDF loading error:", error);
  }, []);

  // Function to handle direct download
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = "/ErayOzcan_CV2025.pdf";
    link.download = 'ErayOzcan_CV2025.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />

        {/* Download Button */}
        <Row style={{ justifyContent: "center", position: "relative", marginBottom: "20px" }}>
          <Button
            variant="primary"
            onClick={handleDownload}
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>

        {/* PDF Viewer */}
        <Row className="resume justify-content-center">
          <Col xs={12}>
            <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  padding: "0 20px",
                  // Key fix: Limit container width on desktop
                  maxWidth: window.innerWidth > 768 ? "700px" : "100%", // Reduced from 800px
                  margin: "0 auto"
                }}
            >
              {error ? (
                  <div className="text-center p-4">
                    <p className="text-danger">{error}</p>
                    <Button
                        variant="outline-primary"
                        onClick={() => window.location.reload()}
                    >
                      Retry
                    </Button>
                  </div>
              ) : (
                  <div style={{
                    display: "inline-block",
                    // Fix: Remove minWidth that was causing stretching
                    width: "fit-content",
                    // Add box shadow for better visual definition
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                    overflow: "hidden"
                  }}>
                    <Document
                        file={"/ErayOzcan_CV2025.pdf"}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={onDocumentLoadError}
                        loading={
                          <div className="text-center p-4">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading PDF...</span>
                            </div>
                            <p className="mt-2">Loading PDF...</p>
                          </div>
                        }
                    >
                      <Page
                          pageNumber={pageNumber}
                          scale={scale}
                          renderTextLayer={false}
                          renderAnnotationLayer={true}
                          loading={
                            <div className="text-center p-4">
                              <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading page...</span>
                              </div>
                            </div>
                          }
                          error={
                            <div className="text-center p-4">
                              <p className="text-danger">Failed to load page.</p>
                            </div>
                          }
                      />
                    </Document>
                  </div>
              )}
            </div>
          </Col>
        </Row>

        {/* Bottom Download Button */}
        <Row style={{ justifyContent: "center", position: "relative", marginTop: "20px" }}>
          <Button
              variant="primary"
              onClick={handleDownload}
              style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;